import { AppConstants } from "../../../../core/constants/constants";
import { LikeParams } from "../../domain/entities/emitLikeParams";
import { MatchSocketRepository } from "../../domain/repositories/SocketRepository";
import { MatchSocketDataSource } from "../datasource/MatchSocketDataSource";

export class MatchRepositorySocketImpl implements MatchSocketRepository {
	constructor(private dataSource: MatchSocketDataSource) {}
	connectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.connectSocket()
		);
	}
	disconnectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.disconnectSocket()
		);
	}
	emitLike(userId: string, type: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.emitLike(userId, type)
		);
	}
	onNotificationLike(callback: (data: LikeParams) => void): void {
		this.dataSource.onNotificationLike(callback)
	}
}
